import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SideBar() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link
            className={
              pathname === "/dashboard"
                ? "nav-link active"
                : "nav-link"
            }
            to="/dashboard"
          >
            <i className="bi bi-grid"></i>
            <span>{t('dashboard')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/users"
                ? "nav-link active"
                : "nav-link"
            }
            to="/users"
          >
            <i className="bi bi-people"></i>
            <span>{t('users')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/networks"
                ? "nav-link active"
                : "nav-link"
            }
            to="/networks"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('networks')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/cryptocurrencies"
                ? "nav-link active"
                : "nav-link"
            }
            to="/cryptocurrencies"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('cryptocurrencies')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/swap"
                ? "nav-link active"
                : "nav-link"
            }
            to="/swap"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('swap')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/reward-settings"
                ? "nav-link active"
                : "nav-link"
            }
            to="/reward-settings"
          >
            <i className="bi bi-cloud-arrow-up"></i>
            <span>{t('reward_settings')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/reward-transactions"
                ? "nav-link active"
                : "nav-link"
            }
            to="/reward-transactions"
          >
            <i className="bi bi-list-ul"></i>
            <span>{t('reward_transactions')}</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname === "/staking-plans"
                ? "nav-link active"
                : "nav-link"
            }
            to="/staking-plans"
          >
            <i className="bi bi-layers"></i>
            <span>{t('staking_plans')}</span>
          </Link>
        </li>

      </ul>
    </aside>
  );
}

export default SideBar;
